
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(258|422|513|699|793|826)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
